import { FC } from 'react'

export const ConsensusEventsList: FC = () => {
  return <>{/* TODO: waits for new designs */}</>
}
